/** The smallest span covering both. */
export function cover(a, b) {
    return [Math.min(a[0], b[0]), Math.max(a[1], b[1])];
}
